import React from "react";
import "../../../AllComponentCSS.css";

function JS_Higher_Order_Functions() {
  return (
    <div className="tutorial-page">
      <h1>JS Higher Order Functions</h1>
      <p>This page will cover the Higher Order Functions topic in detail.</p>
    </div>
  );
}

export default JS_Higher_Order_Functions;
